<template>
  <div class="card">
    <h5 class="card-header">{{title}}</h5>
    <div class="card-body">
      <svg class="horizontal-bars-vis" :height="svgHeight" width="100%">
        <g id="paper" transform="translate(5,0)">
          <g
            class="horizontal-bars-vis__bar-group"
            v-for="item in items"
            v-bind:key="item.code"
            :transform="`translate(0, ${yScale(item.code)})`">
            <rect
              class="bar-group__background"
              :height="yScale.bandwidth()"
              :width="svgWidth - 10" />
            <rect
              class="bar-group__bar"
              :height="yScale.bandwidth()"
              :width="xScale(item.count)" />
            <text
              class="bar-group__group"
              x=5
              :y="yScale.bandwidth() / 2.0">
              {{$t(`${codeEnumScope}.${item.code}`)}}
            </text>
            <text
              class="bar-group__value"
              :x="svgWidth - 10"
              :y="yScale.bandwidth() / 2.0">
              {{$n(item.count)}}
            </text>
            <title>{{$t(`${codeEnumScope}.${item.code}`)}}: {{$n(item.count)}}</title>
          </g>
        </g>
        <g
          id="bottom-axis"
          class="horizontal-bars-vis__bottom-axis"
          :transform="`translate(5,${svgHeight - 20})`"></g>
      </svg>
    </div>
  </div>
</template>

<script>
import { axisBottom } from "d3-axis";
import { format } from "d3-format";
import { scaleBand, scaleLinear } from "d3-scale";
import { select } from "d3-selection";

export default {
  props: ["title", "queryData", "sorted", "codeEnumScope"],
  data(){
    return {
       svgWidth: 300
    }
  },
  computed:{
    items() {
      let items = this.queryData;
      if (this.sorted == "true") {
        items = items.filter(item => item.count > 0)
          .sort((a,b) => b.count - a.count)
      }
      return items;
    },
    xScale() {
      return scaleLinear()
        .range([0, this.svgWidth - 10])
        .domain([0, Math.max(...this.items.map(item => item.count))])
        .nice();
    },
    yScale() {
      return scaleBand()
        .rangeRound([0, this.svgHeight - 20])
        .paddingInner(.1)
        .domain(this.items.map(d => d.code));
    },
    xAxis() {
      return axisBottom(this.xScale)
        .tickFormat(format("~s"));
    },
    svgHeight() {
      return this.items.length * 34 + 20;
    }
  },
  mounted(){
    this.updateAxis();
    window.addEventListener("orientationchange", ()=>{
      setTimeout(this.updateAxis, 10);
    });
  },
  updated(){
    this.updateAxis();
  },
  methods:{
    updateAxis() {
      this.svgWidth = this.$el.querySelector("svg.horizontal-bars-vis").clientWidth;

      const bottomAxis = this.$el.querySelector("#bottom-axis");
      select(bottomAxis).call(this.xAxis);
    }
  }
}
</script>

<style lang="scss">
.horizontal-bars-vis__bar-group {
  .bar-group__background {
    fill-opacity: 0;
  }

  .bar-group__bar {
    fill: #3c5a7f;
    fill-opacity: 0.5;
  }

  .bar-group__group,
  .bar-group__value {
    fill: #333;
    font-size: 12px;
    dominant-baseline: middle;
    text-shadow: rgba(#fff, 0.5) 0 0 2px;
  }

  .bar-group__group {
    font-weight: 600;
  }

  .bar-group__value {
    text-anchor: end;
  }

  &:hover .bar-group__bar {
    fill-opacity: 1;
  }
}

.horizontal-bars-vis__bottom-axis {
  path.domain {
    fill: none;
    stroke: none;
  }

  g.tick {
    line {
      stroke: #e5e5e5;
    }

    text {
      font-size: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Visuals/HorizontalBars.vue